import { IBooleanResponse } from '@gem/models/commonModel';
import { logger } from '@gem/modules/logger';

import { ServerErrorCode } from 'APP/restApi';

import { buildModelError } from '../error/errorBuilder';
import { IGroup } from '../group/groupModel.types';
import {
  IAddSpaceCollectionItems,
  IBannedUsersInSpace,
  IBanUsersInSpaceRequest,
  ICreateSpace,
  ICreateSpaceCollection,
  ICreateSpaceMarket,
  IDeleteSpaceCollectionItems,
  IGetBannedSpaceUsers,
  IGetCollectionIdsWithItems,
  IGetSpaceUserRolesRequest,
  IPersonalizedSpace,
  IPinSpaceResponse,
  ISpaceCollection,
  ISpaceCollectionItem,
  ISpaceCollectionItems,
  ISpaceCollectionRequest,
  ISpaceMarket,
  ISpacePage,
  ISpaceParticipantsChange,
  ISpacesPageRequest,
  ISpaceUserRoleResponse,
  IUpdateGroupVisibilityRequest,
  IUpdateSpace,
  IUpdateSpaceCollection,
  IUpdateSpaceMarket,
  IValidateMarketUrl,
  ISetObsceneFilterRequest,
  ISetKeywordFiltersRequest,
} from './spaceModel.types';

// Needs Bff implementation
export const getSpace = async (spaceId: string): Promise<IPersonalizedSpace> => {
  try {
    return {} as IPersonalizedSpace;
  } catch (error) {
    logger.get('API').error('spaces.getSpace', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const getSpacesPage = async (data: ISpacesPageRequest): Promise<ISpacePage> => {
  try {
    return {} as ISpacePage;
  } catch (error) {
    logger.get('API').error('spaces.getSpacesPage', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const createSpace = async (data: ICreateSpace): Promise<IPersonalizedSpace> => {
  try {
    return {} as IPersonalizedSpace;
  } catch (error) {
    logger.get('API').error('space.createSpace', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const updateSpace = async (data: IUpdateSpace): Promise<IPersonalizedSpace> => {
  try {
    return {} as IPersonalizedSpace;
  } catch (error) {
    logger.get('API').error('space.updateSpace', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const revokeFromAdmin = async (
  data: ISpaceParticipantsChange
): Promise<IBooleanResponse> => {
  try {
    return { result: false };
  } catch (error) {
    logger.get('API').error('space.revokeFromAdmin', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const removeParticipants = async (
  data: ISpaceParticipantsChange
): Promise<IBooleanResponse> => {
  try {
    return { result: false };
  } catch (error) {
    logger.get('API').error('space.removeParticipants', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const promoteToAdmin = async (data: ISpaceParticipantsChange): Promise<IBooleanResponse> => {
  try {
    return { result: false };
  } catch (error) {
    logger.get('API').error('space.promoteToAdmin', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const joinSpace = async (spaceId: string): Promise<IPersonalizedSpace> => {
  try {
    return {} as IPersonalizedSpace;
  } catch (error) {
    logger.get('API').error('space.joinSpace', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const getAvailableGroups = async (spaceId: string): Promise<IGroup[]> => {
  try {
    return [];
  } catch (error) {
    logger.get('API').error('spaces.getAvailableGroups', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const moveGroupsToSpace = async (
  spaceId: string,
  groupIds: string[]
): Promise<IPersonalizedSpace> => {
  try {
    return {} as IPersonalizedSpace;
  } catch (error) {
    logger.get('API').error('spaces.moveGroupsToSpace', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const leaveSpace = async (spaceId: string): Promise<IPersonalizedSpace> => {
  try {
    return {} as IPersonalizedSpace;
  } catch (error) {
    logger.get('API').error('spaces.leaveSpace', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const deleteSpace = async (
  spaceId: string,
  groupIds?: string[]
): Promise<IBooleanResponse> => {
  try {
    return { result: false };
  } catch (error) {
    logger.get('API').error('spaces.deleteSpace', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const unlinkGroups = async (groupIds: string[]): Promise<IBooleanResponse> => {
  try {
    return { result: false };
  } catch (error) {
    logger.get('API').error('spaces.unlinkGroups', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const getMarkets = async (spaceId: string): Promise<ISpaceMarket[]> => {
  try {
    return [];
  } catch (error) {
    logger.get('API').error('spaces.getMarkets', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const createMarket = async (data: ICreateSpaceMarket): Promise<ISpaceMarket> => {
  try {
    return {
      id: '',
      name: '',
      spaceId: '',
      url: '',
    };
  } catch (error) {
    logger.get('API').error('spaces.createMarket', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const updateMarket = async (data: IUpdateSpaceMarket): Promise<ISpaceMarket> => {
  try {
    return {
      id: '',
      name: '',
      spaceId: '',
      url: '',
    };
  } catch (error) {
    logger.get('API').error('spaces.updateMarket', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const deleteMarket = async (
  spaceId: string,
  marketId: string
): Promise<IBooleanResponse> => {
  try {
    return { result: false };
  } catch (error) {
    logger.get('API').error('spaces.deleteMarket', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const banUsers = async (data: IBanUsersInSpaceRequest): Promise<IBooleanResponse> => {
  try {
    return { result: false };
  } catch (error) {
    logger.get('API').error('spaces.banUsers', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const unbanUsers = async (data: ISpaceParticipantsChange): Promise<IBooleanResponse> => {
  try {
    return { result: false };
  } catch (error) {
    logger.get('API').error('spaces.unbanUsers', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const getBannedUsers = async (data: IGetBannedSpaceUsers): Promise<IBannedUsersInSpace> => {
  try {
    return { userIds: [], cursor: '' };
  } catch (error) {
    logger.get('API').error('spaces.getBannedUsers', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const getCollections = async (spaceId: string): Promise<ISpaceCollection[]> => {
  try {
    return [];
  } catch (error) {
    logger.get('API').error('spaces.getCollections', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const createCollection = async (data: ICreateSpaceCollection): Promise<ISpaceCollection> => {
  try {
    return {} as ISpaceCollection;
  } catch (error) {
    logger.get('API').error('spaces.createCollection', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const updateCollection = async (data: IUpdateSpaceCollection): Promise<ISpaceCollection> => {
  try {
    return {} as ISpaceCollection;
  } catch (error) {
    logger.get('API').error('spaces.updateCollection', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const addCollectionItems = async (
  data: IAddSpaceCollectionItems
): Promise<ISpaceCollectionItem[]> => {
  try {
    return [];
  } catch (error) {
    logger.get('API').error('spaces.addCollectionItems', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const getCollectionIdsWithItems = async (
  data: IGetCollectionIdsWithItems
): Promise<string[]> => {
  try {
    return [];
  } catch (error) {
    logger.get('API').error('spaces.getCollectionIdsWithItems', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const deleteCollection = async (data: ISpaceCollectionRequest): Promise<boolean> => {
  try {
    return false;
  } catch (error) {
    logger.get('API').error('spaces.deleteCollection', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const getCollectionItems = async (
  data: ISpaceCollectionRequest
): Promise<ISpaceCollectionItems> => {
  try {
    return {} as ISpaceCollectionItems;
  } catch (error) {
    logger.get('API').error('spaces.getCollectionItems', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const deleteCollectionItems = async (
  data: IDeleteSpaceCollectionItems
): Promise<IBooleanResponse> => {
  try {
    return { result: false };
  } catch (error) {
    logger.get('API').error('spaces.deleteCollectionItems', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const validateMarketUrl = async (data: IValidateMarketUrl): Promise<boolean> => {
  try {
    return false;
  } catch (error) {
    if (error.message === ServerErrorCode.MarketUrlNotValid) {
      return false;
    }

    logger.get('API').error('spaces.validateMarketUrl', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const pinSpaces = async (spaceIds: string[]): Promise<IPinSpaceResponse[]> => {
  try {
    return [];
  } catch (error) {
    logger.get('API').error('spaces.pinSpaces', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const unpinSpaces = async (spaceIds: string[]): Promise<IPinSpaceResponse[]> => {
  try {
    return [];
  } catch (error) {
    logger.get('API').error('spaces.unpinSpaces', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const getUserRoles = async (
  data: IGetSpaceUserRolesRequest
): Promise<ISpaceUserRoleResponse> => {
  try {
    return {} as ISpaceUserRoleResponse;
  } catch (error) {
    logger.get('API').error('spaces.getUserRoles', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const changeOwnership = async (spaceId: string, newOwnerId: string): Promise<boolean> => {
  try {
    return false;
  } catch (error) {
    logger.get('API').error('spaces.changeOwnership', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const updateGroupVisibility = async (
  data: IUpdateGroupVisibilityRequest
): Promise<boolean> => {
  try {
    return false;
  } catch (error) {
    logger.get('API').error('spaces.updateGroupVisibility', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const setObsceneFilter = async (data: ISetObsceneFilterRequest): Promise<boolean> => {
  try {
    return false;
  } catch (error) {
    logger.get('API').error('space.setObsceneFilter', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export async function getKeywordFilters(spaceId: string): Promise<string[]> {
  try {
    return [];
  } catch (error) {
    logger.get('API').error('space.getKeywordFilters', error);
    throw buildModelError(error);
  }
}

// Needs Bff implementation
export async function setKeywordFilters(data: ISetKeywordFiltersRequest): Promise<boolean> {
  try {
    return false;
  } catch (error) {
    logger.get('API').error('space.setKeywordFilters', error);
    throw buildModelError(error);
  }
}
